module.exports = __webpack_public_path__ + "static/media/boss_clothes.954e3626.svg";